import Icon from '../components/Icon.vue'

Icon.register({
  'sort-numeric-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M308.8 113.8l-19.4-20.8c-4.5-4.8-4.3-12.4 0.6-17l43.4-40.7c1.9-1.8 5.6-3.2 8.2-3.2h0 31.6c6.6 0 12 5.4 12 12v127.1h25.7c6.6 0 12 5.4 12 12v28.9c0 6.6-5.4 12-12 12h-109.2c-6.6 0-12-5.4-12-12v-28.9c0-6.6 5.4-12 12-12h25.4v-57.9c-7.3 6.6-14.2 4.9-18.3 0.6zM278.2 352.4c0-32.7 23.9-67.4 68.1-67.4 38.3 0 79.4 28.9 79.4 92.2 0 51.3-32.2 105.8-92 105.8-17.8 0-30.5-3.6-38.5-6.8-5.8-2.3-8.8-8.7-6.9-14.7l9.2-29.5c2-6.5 9-10 15.5-7.7 13 4.6 27.9 5.3 38.1-4.1-38.7 5.1-72.9-25.4-72.9-67.8zM370.5 371.7c0-22.3-15.3-36.5-25.8-36.5-8.6 0-13.2 8-13.2 15.8 0 5.7 1.8 24.2 25.2 24.2 10 0 13.4-2.2 13.7-2.7 0 0 0.1-0.3 0.1-0.8zM176 368c14.2 0 21.4 17.3 11.3 27.3l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-10.1-10.1-2.9-27.3 11.3-27.3h48v-320c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v320h48z'
      }
    ]
  }
})
